import React from "react";
import { PageLayout, SubmitButton } from "../../components";
import { TellUsAboutYourCarHelmet } from "../../components/SellHelmets";
import FactualQuestionCompactView from "./FactualQuestionCompactView";
import {
  ComponentType,
  RadioAndTooltipContent,
  questionPresentationContent
} from "../../data/QuestionPresentation";
import { RadioAndToolTipQuestionCompact } from "../ConditionQuestionsCompactView/components/RadioAndToolTipQuestionCompact";

interface IFactualQuestionsProps {
  questions: Question[];
  handleSubmit: (questions: Question[]) => void;
  handleChange: (answer: number, question: number) => void;
  questionsAndAnswers: ChosenAnswer[];
  isContinueClicked: boolean;
}

export default function FactualQuestionsCompactView({
  questions,
  handleSubmit,
  handleChange,
  questionsAndAnswers,
  isContinueClicked
}: IFactualQuestionsProps) {
  const questionsToRender = () => {
    return questions?.map((question, i) => {
      const {
        component: { content }
      } = questionPresentationContent[question.id];
      const tooltipContent = content as RadioAndTooltipContent;
      return (
        <>
          {questionPresentationContent[question.id]?.component?.type ===
            ComponentType.RADIOWITHTOOTIP &&
          tooltipContent?.compactView?.showTooltip ? (
            <div
              className="ch-form__group ch-pt--4 ch-pb--6 radio-tooltip-container"
              key={i}
            >
              <RadioAndToolTipQuestionCompact
                question={question}
                factualQuestion={true}
                replaceManufacturerName={
                  tooltipContent?.replaceManufacturerName
                }
              />
            </div>
          ) : (
            <div key={i}>
              <FactualQuestionCompactView
                question={question}
                questionsAndAnswers={questionsAndAnswers}
                handleChange={handleChange}
                isContinueClicked={isContinueClicked}
              />
            </div>
          )}
        </>
      );
    });
  };
  return (
    <>
      <TellUsAboutYourCarHelmet />
      <PageLayout>
        <PageLayout.Header title="Tell us about your car" step={3} />
        <PageLayout.CompactView>
          <h3 className="ch-text--normal ch-pb--3 ch-pt--7">
            About the vehicle
          </h3>
          {questionsToRender()}
          <SubmitButton
            onSubmit={() => handleSubmit(questions)}
            buttonText="Continue"
          />
        </PageLayout.CompactView>
      </PageLayout>
    </>
  );
}
